var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('error',{attrs:{"name":'500',"desc":'抱歉，服务器出错了'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }